import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import Table from "../../../components/Table"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { deleteData, fetchData, postData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import UploadFile from "../../Utils/UploadFile"
import InsurerBodyStyleFilterDialog from './components/InsurerBodyStyleFilterDialog.js';

const InsurerBodyStyleList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.insurerBodyStyleStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.insurerBodyStyleStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.insurerBodyStyleStore?.totalPages);

    const [insurerBodyStyleData, setInsurerBodyStyleData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        gInsurerId: "",
        mBodyStyleId: "",
        iBodyTypeId: ""
    });

    useEffect(() => {
        fetchBodyStyleList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchBodyStyleList = async () => {
        setCircleLoading(true)
        try {
        let url = `/reference/insurer/body-style?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}
        &gInsurerId=${filterData?.gInsurerId}&mBodyStyleId=${filterData?.mBodyStyleId}&iBodyTypeId=${filterData?.iBodyTypeId}`;
                        
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }

        const response = await fetchData(url);
        if(response?.success){
            setInsurerBodyStyleData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Body Style List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Body Styles:', error);
            showSnackbar(error?.response?.data?.message, "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/motor/insurer/bulkUpload/insurer-body-style`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
            setUploadSuccess(true)
            showSnackbar(result?.message,"success");
            setOpenUploadFileDialog(false);
            setClearFileOnSuccess(true);
            fetchBodyStyleList(); 
            }
            else {
            setUploadSuccess(false);
            showSnackbar('Faiiled to upload file', "error")
            }

        }catch(error) {
            const errorMessage = error?.response?.data?.message;                
            console.error('Upload error:', error || errorMessage)
            showSnackbar(errorMessage, "error")
        } 
        finally{
            setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/insurer/body-style/-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    //table mapping
    const insurerBodyStyleTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "code",
            label: "Code",
            renderCell: (row) => row.code,
            },
            {
            key: "name",
            label: "Body Style",
            renderCell: (row) => row.name,
            },
            {
            key: "gInsurerName",
            label: "Insurer Name",
            renderCell: (row) => row.gInsurerId,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: insurerBodyStyleData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            code: item?.code || "",
            name: item?.name || "",
            gInsurerId: item?.gInsurerId,
            gInsurerName: item?.gInsurerName || "",
            isActive: item?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/insurer-master/body-style/body-style-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/insurer-master/body-style/body-style-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleAddNewBodyStyle = () => {
        navigate('/insurer-master/body-style/body-style-details');
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Insurer Body Style List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Body Styles linked to Insurers.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                    onClick={() => setOpenUploadFileDialog(true)}>
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => handleAddNewBodyStyle()}
                    >
                        Insurer Body Style
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
            <Table
            columns={insurerBodyStyleTable?.columns}
            data={insurerBodyStyleTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Insurer Body Styles found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <InsurerBodyStyleFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchBodyStyleList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default InsurerBodyStyleList